import { render, staticRenderFns } from "./CommonQuote.vue?vue&type=template&id=0ec87c40&scoped=true&"
import script from "./CommonQuote.vue?vue&type=script&lang=ts&"
export * from "./CommonQuote.vue?vue&type=script&lang=ts&"
import style0 from "./CommonQuote.vue?vue&type=style&index=0&id=0ec87c40&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec87c40",
  null
  
)

export default component.exports